export const PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAwO0ni0e3JjEBfpjlNCak
9KdTg1kqTQFmqj+QyGeeE4ZUgNSx9IFUANzTL7Nrw0i24iEKYUu+l0m8duSTAafv
BvgJoj9CKx8R7pVuR//6h/jH6R2u1PKBYeiq+oRAAm0ZP3pXHCTKfyOJKv2d6L9H
ojcgI5WXKKE0Shv5DV+rURknU6trG1QIgUg5lwqy5ZSd2p81g8PdQKHs50yZOvIc
+IR/l2BciVUXAg2O8hdXoxnhzXpJ/aBICgIKDBQ3cTkUizUlQw78PK8Eh85w/V9s
rB45W1tn34wVAiai1dNuMLOCy+n+YgYzIYnlSvqD2ADO+i3wzLvgzGp/V2m0TyqT
XwIDAQAB
-----END PUBLIC KEY-----`;